import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/layout';
import MetaData from '../components/meta-data';
import Headline from '../components/headline';
import Tiles from '../components/tiles';
var IndexPage = function IndexPage(props) {
    var _props$data, _props$data$seo, _props$data$seo$edges, _props$data2, _props$data2$seo, _props$data2$seo$edge, _props$data3, _props$data3$seo, _props$data3$seo$edge, _props$data4, _props$data4$dtProfil, _props$data4$dtProfil2, _props$data5, _props$data5$travel, _props$data5$travel$e, _props$data5$travel$e2, _props$data5$travel$e3, _props$data6, _props$data6$food, _props$data6$food$edg, _props$data6$food$edg2, _props$data6$food$edg3, _props$data7, _props$data7$paintbal, _props$data7$paintbal2, _props$data7$paintbal3, _props$data7$paintbal4, _props$data8, _props$data8$people, _props$data8$people$e, _props$data8$people$e2, _props$data8$people$e3, _props$data9, _props$data9$cars, _props$data9$cars$edg, _props$data9$cars$edg2, _props$data9$cars$edg3, _props$data10, _props$data10$project, _props$data10$project2, _props$data10$project3, _props$data10$project4;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "Drew Templeton | Chicago based creator \uD83D\uDCA1, tech lover \uD83E\uDD13 and market enthusiast \uD83D\uDCC8.",
        description: 'The portfolio and work home of Drew Templeton. Photography, software, video and stories all rolled into one.',
        photos: {
            full: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$seo = _props$data.seo) === null || _props$data$seo === void 0 ? void 0 : (_props$data$seo$edges = _props$data$seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : (_props$data2$seo = _props$data2.seo) === null || _props$data2$seo === void 0 ? void 0 : (_props$data2$seo$edge = _props$data2$seo.edges[0].node.facebook) === null || _props$data2$seo$edge === void 0 ? void 0 : _props$data2$seo$edge.fixed,
            twitter: (_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : (_props$data3$seo = _props$data3.seo) === null || _props$data3$seo === void 0 ? void 0 : (_props$data3$seo$edge = _props$data3$seo.edges[0].node.twitter) === null || _props$data3$seo$edge === void 0 ? void 0 : _props$data3$seo$edge.fixed
        }
    }), /*#__PURE__*/ React.createElement("header", {
        className: "home__header"
    }, /*#__PURE__*/ React.createElement(Headline, {
        image: {
            source: (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : (_props$data4$dtProfil = _props$data4.dtProfilePhoto) === null || _props$data4$dtProfil === void 0 ? void 0 : (_props$data4$dtProfil2 = _props$data4$dtProfil.edges[0].node.childImageSharp) === null || _props$data4$dtProfil2 === void 0 ? void 0 : _props$data4$dtProfil2.fluid,
            altText: 'Drew Templeton'
        },
        copy: {
            headline: {
                h1: 'Templeton',
                span: 'Drew'
            },
            text: 'Chicago based creator 💡, technology lover 🤓 and market enthusiast 📈',
            link: {
                linksTo: 'https://instagram.com/drewbie613',
                outbound: true,
                text: '@drewbie613'
            }
        }
    })), /*#__PURE__*/ React.createElement("section", {
        className: "home__content"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "copy"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "photos/"
    }, /*#__PURE__*/ React.createElement("h1", null, "Photos")), /*#__PURE__*/ React.createElement("p", null, "Some looks at my most recent photos. If you're looking to hire a photographer. I enjoy all different types of shoots; portraits, product, lifestyle, food and cars. Feel free to contact me if you'd like to work together."), /*#__PURE__*/ React.createElement("a", {
        href: "mailto:drew@drewtempleton.com"
    }, /*#__PURE__*/ React.createElement("button", null, "Contact Me"))), /*#__PURE__*/ React.createElement(Tiles, {
        grid: true,
        tiles: [{
                id: props.data.travel.edges[0].node.id,
                image: {
                    fluid: (_props$data5 = props.data) === null || _props$data5 === void 0 ? void 0 : (_props$data5$travel = _props$data5.travel) === null || _props$data5$travel === void 0 ? void 0 : (_props$data5$travel$e = _props$data5$travel.edges[0]) === null || _props$data5$travel$e === void 0 ? void 0 : (_props$data5$travel$e2 = _props$data5$travel$e.node) === null || _props$data5$travel$e2 === void 0 ? void 0 : (_props$data5$travel$e3 = _props$data5$travel$e2.childImageSharp) === null || _props$data5$travel$e3 === void 0 ? void 0 : _props$data5$travel$e3.fluid,
                    altText: 'Gum Wall, Seattle Washington'
                },
                link: '/photos/travel/',
                copy: {
                    headline: {
                        h1: 'Travels'
                    }
                }
            }, {
                id: props.data.food.edges[0].node.id,
                image: {
                    fluid: (_props$data6 = props.data) === null || _props$data6 === void 0 ? void 0 : (_props$data6$food = _props$data6.food) === null || _props$data6$food === void 0 ? void 0 : (_props$data6$food$edg = _props$data6$food.edges[0]) === null || _props$data6$food$edg === void 0 ? void 0 : (_props$data6$food$edg2 = _props$data6$food$edg.node) === null || _props$data6$food$edg2 === void 0 ? void 0 : (_props$data6$food$edg3 = _props$data6$food$edg2.childImageSharp) === null || _props$data6$food$edg3 === void 0 ? void 0 : _props$data6$food$edg3.fluid,
                    altText: 'Oak + Char'
                },
                link: '/photos/food/',
                copy: {
                    headline: {
                        h1: 'F🤤🤤D'
                    }
                }
            }, {
                id: props.data.paintball.edges[0].node.id,
                image: {
                    fluid: (_props$data7 = props.data) === null || _props$data7 === void 0 ? void 0 : (_props$data7$paintbal = _props$data7.paintball) === null || _props$data7$paintbal === void 0 ? void 0 : (_props$data7$paintbal2 = _props$data7$paintbal.edges[0]) === null || _props$data7$paintbal2 === void 0 ? void 0 : (_props$data7$paintbal3 = _props$data7$paintbal2.node) === null || _props$data7$paintbal3 === void 0 ? void 0 : (_props$data7$paintbal4 = _props$data7$paintbal3.childImageSharp) === null || _props$data7$paintbal4 === void 0 ? void 0 : _props$data7$paintbal4.fluid,
                    altText: 'Drew Templeton Paintball Photos'
                },
                link: '/photos/paintball',
                copy: {
                    headline: {
                        h1: 'Paintball'
                    }
                }
            }, {
                id: props.data.people.edges[0].node.id,
                image: {
                    fluid: (_props$data8 = props.data) === null || _props$data8 === void 0 ? void 0 : (_props$data8$people = _props$data8.people) === null || _props$data8$people === void 0 ? void 0 : (_props$data8$people$e = _props$data8$people.edges[0]) === null || _props$data8$people$e === void 0 ? void 0 : (_props$data8$people$e2 = _props$data8$people$e.node) === null || _props$data8$people$e2 === void 0 ? void 0 : (_props$data8$people$e3 = _props$data8$people$e2.childImageSharp) === null || _props$data8$people$e3 === void 0 ? void 0 : _props$data8$people$e3.fluid,
                    altText: 'Drew Templeton People Photos'
                },
                link: '/photos/people/',
                copy: {
                    headline: {
                        h1: 'People',
                        span: 'Yep, Miles is a person'
                    }
                }
            }, {
                id: props.data.cars.edges[0].node.id,
                image: {
                    fluid: (_props$data9 = props.data) === null || _props$data9 === void 0 ? void 0 : (_props$data9$cars = _props$data9.cars) === null || _props$data9$cars === void 0 ? void 0 : (_props$data9$cars$edg = _props$data9$cars.edges[0]) === null || _props$data9$cars$edg === void 0 ? void 0 : (_props$data9$cars$edg2 = _props$data9$cars$edg.node) === null || _props$data9$cars$edg2 === void 0 ? void 0 : (_props$data9$cars$edg3 = _props$data9$cars$edg2.childImageSharp) === null || _props$data9$cars$edg3 === void 0 ? void 0 : _props$data9$cars$edg3.fluid,
                    altText: 'Drew Templeton Car Photos'
                },
                link: '/photos/cars/',
                copy: {
                    headline: {
                        h1: 'Cars'
                    }
                }
            }, {
                id: props.data.cars.edges[0].node.id,
                image: {
                    fluid: (_props$data10 = props.data) === null || _props$data10 === void 0 ? void 0 : (_props$data10$project = _props$data10.projects) === null || _props$data10$project === void 0 ? void 0 : (_props$data10$project2 = _props$data10$project.edges[0]) === null || _props$data10$project2 === void 0 ? void 0 : (_props$data10$project3 = _props$data10$project2.node) === null || _props$data10$project3 === void 0 ? void 0 : (_props$data10$project4 = _props$data10$project3.childImageSharp) === null || _props$data10$project4 === void 0 ? void 0 : _props$data10$project4.fluid,
                    altText: 'Drew Templeton Project Photos'
                },
                link: '/photos/projects/',
                copy: {
                    headline: {
                        h1: 'Projects'
                    }
                }
            }]
    })));
};
export default IndexPage;
var query = "3283651898";
